var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "p",
    {
      staticClass: "app-calendar-event-card event-item",
      class: _vm.cssClasses,
      on: {
        click: function($event) {
          return _vm.$emit("click", _vm.event, $event)
        }
      }
    },
    [
      _vm.showTitle
        ? _vm._t("default", [_vm._v(_vm._s(_vm.event.title))], {
            event: _vm.event
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }